<template>
  <div class="multiInputBox">
    <el-tabs type="border-card" v-model="activeLang">
      <el-tab-pane label="简体中文" name="zh">
        <div class="input-box">
          <el-input :type="type" v-model="name.zh_CN" placeholder="请输入中文" @change="change"></el-input>
        </div>
      </el-tab-pane>
      <el-tab-pane label="繁体中文" name="other">
        <el-input :type="type" v-model="name.zh_HK" placeholder="请输入繁体中文" @change="change"></el-input>
      </el-tab-pane>
      <el-tab-pane label="English" name="en">
        <el-input :type="type" v-model="name.en" placeholder="Please enter English" @change="change"></el-input>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { multiInputFormat } from '../utils/global'
import _ from 'lodash'

export default {
  name: 'multiInput',
  props: {
    value: Object,
    isTextArea: Boolean
  },
  data () {
    return {
      activeLang: 'zh', // 当前展示的语言
      name: _.clone(multiInputFormat),
      type: this.isTextArea ? 'textarea' : ''
    }
  },
  mounted () {
    this.name = this.value
  },
  watch: {
    value: function (val, oldVal) {
      this.name = val
    }
  },
  methods: {
    change: function () {
      console.log('同步多语言文本框')
      this.$emit('input', this.name)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/topdoor/components/multiInput.vue